import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * models
 **/
import MODEL_ENV from './models/env';
import MODEL_EVENT from './models/event';
import MODEL_LETTERS from './models/letters';
import MODEL_PARAM from './models/param';
import MODEL_POINTER from './models/pointer';
import MODEL_SIZE from './models/size';

/**
 * controllers
 **/
import CONTROLLER_COMMON from './controllers/common';

class App{

    /**
     * constructor
     */
    constructor(){
        gsap.registerPlugin(ScrollTrigger);

        // models
        window.MODEL = {
            env: new MODEL_ENV(),
            event: new MODEL_EVENT(),
            letters: new MODEL_LETTERS(),
            param: new MODEL_PARAM(),
            pointer: new MODEL_POINTER(),
            size: new MODEL_SIZE()
        };

        // controllers
        this.controllers = {
            common: new CONTROLLER_COMMON()
        };
    }

    /**
     * init
     */
    init(){
        for (const [key, value] of Object.entries(this.controllers)) {
            if (key === 'common') {
                value.init();
            } else {
                if (document.querySelector('#page-' + key)) value.init();
            };
        };
    }

}

const APP = new App();
APP.init();